import compensations from './compensations'
import give_outs from './give_outs'
import give_outs_approved from './give_outs_approved'


export default {
    compensations,
    give_outs,
    give_outs_approved,
}